import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Breadcrumbs from "../components/breadcrumbs/Breadcrumbs";
import nagadLogo from "../assets/images/nagad-logo.png";
import Laoder from "../components/loader/Loader";
import bkashLogo from "../assets/images/bkash-logo.png";
import cardLogo from "../assets/images/card-logo.png";
import rocketLogo from "../assets/images/rocket-logo.png";
import AppConstants from "../constants/AppConstants";
import api from "../api/api";

export default function CheckoutPayment() {
  const { handShakeStatus } = useSelector((state) => state.deviceSlice);
  const location = useLocation();
  const state = location.state || {};
  const bookingId = state?.booking_id || "";
  const discountedPrice = state?.discountedPrice || 0;
  const discount = state?.discount || 0;
  const totalPrice = state?.totalPrice || 0;
  const [isConfirmChecked, setIsConfirmChecked] = useState(false);

  const [paymentMethodsArr, setPaymentMethodsArr] = useState([]);
  const [selectedPaymentMethod, setSelectedMethod] = useState({});

  const [loading, setLoading] = useState(false);

  const isMounted = useRef(true);

  function handleSelectPaymentMethod(selectedMethod) {
    console.log({selectedMethod})
    const selectedPaymentsMethod = {
      ...selectedMethod,
      isSelected: true,
    };
    setSelectedMethod(selectedPaymentsMethod);
    setPaymentMethodsArr((prev) =>
      prev.map((method) => ({
        ...method,
        isSelected:
          method.name === selectedMethod.name ? !method.isSelected : false,
      }))
    );
  }

  function isPaymentMethodSelected() {
    return paymentMethodsArr.some((method) => method.isSelected);
  }

  const handlePayment = async () => {
    try {
      setLoading(true);
      const res = await api.payment({
        payment_mode: selectedPaymentMethod?.shortCode,
        booking_id: bookingId,
      });

      if (res?.status === 201) {
        window.location.href = res.data.data.redirectURL;
      } else {
        console.error("Payment failed:", res);
      }
    } catch (error) {
      console.error("Error processing payment:", error);
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (handShakeStatus) {
      const handshakeData = sessionStorage.getItem(
      AppConstants.SS_KEY.HANDSHAKE_DATA
    );
    if (!handshakeData) return;

    const handshakeRes = JSON.parse(handshakeData);
    const allMethods = handshakeRes?.paymentMethods || {};

    const iconMap = {
      bKash: bkashLogo,
      Nagad: nagadLogo,
      Rocket: rocketLogo,
      "Debit/Credit Card": cardLogo,
    };

    const preferredOrder = ["bKash", "Nagad", "Rocket", "Debit/Credit Card"];

    const combinedMethods = Object.values(allMethods)
      .filter((category) => category?.isActive)
      .reduce((acc, category) => acc.concat(category?.options || []), [])
      .map((method) => ({
        id: method.value,
        name: method.name,
        shortCode: method.shortCode,
        isActive: method.isActive,
        isSelected: false,
        icon: iconMap[method.name] || null,
      }))
      .sort(
        (a, b) =>
          preferredOrder.indexOf(a.name) -
          preferredOrder.indexOf(b.name)
      );

    setPaymentMethodsArr(combinedMethods);
    }
  }, [handShakeStatus]);

  return (
    <div style={{ backgroundColor: "#f2f5f8" }}>
      <Breadcrumbs activeId={5} />

      <div className="container py-3">
        {loading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              backgroundColor: "rgba(255,255,255,0.7)",
              zIndex: 9999,
            }}
          >
            <Laoder />
          </div>
        )}
        <div className="row justify-content-around">
          {/* Left Side */}
          <div className="col-lg-7 mb-4">
            {/* Agreement */}
            <div
              className="d-flex align-items-start gap-2 mb-3"
              style={{
                fontSize: "0.85rem",
                backgroundColor: "white",
                padding: "1rem",
                borderRadius: "8px",
              }}
            >
              <label htmlFor="agreement">
                <input
                  className="me-2"
                  id="agreement"
                  type="checkbox"
                  style={{ marginTop: "4px" }}
                  checked={isConfirmChecked}
                  onChange={(e) => setIsConfirmChecked(e.target.checked)}
                />
                I am confirming that I have read, acknowledged and agree to
                the&nbsp;
                <a
                  href="/terms-of-use"
                  className="text-success bg-white border-0 p-0"
                >
                  <u>
                    <strong>Terms of Use</strong>
                  </u>
                </a>
                ,
                <a
                  href="/privacy-policy"
                  className="text-success bg-white border-0 p-0 ps-1"
                >
                  <u>
                    <strong>Privacy Policy</strong>
                  </u>
                </a>
                ,
                <a
                  href="/cancellation-and-refunds"
                  className="text-success bg-white border-0 p-0 ps-1"
                >
                  <u>
                    <strong>Cancellation Policy</strong>
                  </u>
                </a>{" "}
                of Shohoz.com
              </label>
            </div>

            {/* Payment Methods */}
            <div
              className="bg-white"
              style={{ padding: "1rem", borderRadius: "10px" }}
            >
              <h6 style={{ fontWeight: 600 }}>SELECT PAYMENT METHOD</h6>
              <div className="row mt-3">
                {paymentMethodsArr.map(
                  (method) =>
                    method.isActive && (
                      <div key={method.id} className="col-md-6 mb-3">
                        <button
                          type="button"
                          className="d-flex align-items-center justify-content-between p-3 w-100 btn"
                          style={{
                            background: "#f4f4f4",
                            borderRadius: "8px",
                            cursor: "pointer",
                            border: method.isSelected
                              ? "2px solid #478946"
                              : "2px solid transparent",
                          }}
                          onClick={() => handleSelectPaymentMethod(method)}
                        >
                          <div>
                            <img
                              className="me-3"
                              src={method.icon}
                              alt={method.name}
                            />{" "}
                            {method.name}
                          </div>
                          <span>
                            <i
                              className="fa-solid fa-check"
                              style={{
                                color: method.isSelected
                                  ? "#478946"
                                  : "#dddddd",
                              }}
                            />
                          </span>
                        </button>
                      </div>
                    )
                )}
              </div>
              <div className="d-flex">
                <i className="fa-solid fa-circle-info me-2 mt-1 text-success"/>
                <p>Processing fee will be added with the ticket fare during payment, that will vary depending on MFS and Bank</p>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-lg-4">
            {/* Price Summary */}
            <div className="bg-white p-3 rounded-top">
              <div
                style={{
                  background: "#f8f8f8",
                  borderRadius: "10px",
                  padding: "1rem",
                }}
              >
                <div className="d-flex justify-content-between mb-2">
                  <strong>PRICE SUMMARY</strong>
                  <span className="text-muted">
                    Online Payment
                    <span
                      className="rounded p-1 ms-2 text-white"
                      style={{ backgroundColor: "#f88922" }}
                    >
                      ৳
                    </span>
                  </span>
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <span>Ticket Price</span>
                  <span>৳ {totalPrice}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Discount</span>
                  <span>৳ {discount}</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <strong style={{ color: "green" }}>TOTAL PAYABLE</strong>
                  <p className="mb-0">
                    <span style={{ color: "#f88922", fontSize: "20px" }}>
                      <b>৳ {discountedPrice}</b>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            {/* Park Terms */}
            <div
              style={{
                backgroundColor: "#e6f4ea",
                padding: "1rem",
                fontSize: "0.85rem",
                // borderRadius: "0.25rem",
                // marginTop: "1rem"
                borderBottom: "1px solid #ccc",
              }}
            >
              <strong>Terms & Condition</strong>
              <ul className="mb-0">
                <li>All tickets are <b>non-exchangeable, non-cancelable, and non-refundable</b></li>
                <li>Outside food is <b>not allowed</b> inside the park</li>
                <li>All standard <b>ticket conditions apply</b></li>
                <li>Children must be <b>under {`4'3"`}</b> to qualify for child tickets</li>
              </ul>
            </div>

            {/* Notes */}
            {/* <div
              style={{
                backgroundColor: "#e6f4ea",
                padding: "1rem",
                fontSize: "0.85rem",
                borderRadius: "0.25rem",
                // marginTop: "1rem"
              }}
            >
              <strong>PLEASE NOTE</strong>
              <ul className="mb-0">
                <li>Processing Fees and Bank Charges are non-refundable</li>
                <li>Dhaka delivery charge revised to 50 tk</li>
                <li>
                  Cancellation allowed. See&nbsp;
                  <a href="/cancellation-and-refunds" className="text-success">
                    cancellation & refund policy
                  </a>
                </li>
              </ul>
            </div> */}

            {/* Proceed Button */}
            <button
              type="button"
              className="btn btn-success w-100 mt-3"
              style={{
                fontWeight: 600,
                backgroundColor: "#079d49",
                marginBottom: "100px",
              }}
              onClick={handlePayment}
              disabled={!isPaymentMethodSelected() || !isConfirmChecked}
            >
              PROCEED TO PAYMENT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
